import React, { useEffect } from "react"
import { withMainLayout } from "../view/LayoutHOCs";
import { connect } from "react-redux";
import * as layoutService from "../view/layoutService";
import { InfoBoxes } from "../info-boxes/InfoBoxes";
import ChartSection from "./ChartSection";

const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    }
]

function DashboardPage() {

    useEffect(() => {
        layoutService.setPageTitle("Dashboard")
        layoutService.setBreadcrumbs(breadcrumbs)
    })

    return (<>
        <InfoBoxes />
        <ChartSection />
    </>);
}


export default withMainLayout(connect()(DashboardPage));